import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { TablaFamilias } from "./TablaFamilias";
import { useCallback, useEffect, useState } from "react";
import { Loading, QueryError } from "@/components/Loading/Loading";
import { notificacion, notificacionError } from "@/components/Alerts";
import type { RowSelectionState } from "@tanstack/react-table";

export function GestionFamiliasOcultasPage() {
	const queryClient = useQueryClient();
	const { data, error, isPending } = useFamiliasOcultas();
	const [familiasOcultas, setFamiliasOcultas] = useState<RowSelectionState>({});
	const [subfamiliasOcultas, setSubfamiliasOcultas] = useState<RowSelectionState>({});

	useEffect(() => {
		if (!data) return;

		const famOcultas: RowSelectionState = {};
		const subfamOcultas: RowSelectionState = {};

		data.familiasOcultas.forEach(id => { famOcultas[id] = true; });
		data.subfamiliasOcultas.forEach(id => { subfamOcultas[id] = true; });

		// TODO Esto necesitaria un estado dirty a combinar con el pristine, para evitar el useEffect
		// eslint-disable-next-line react-hooks/set-state-in-effect
		setFamiliasOcultas(famOcultas);
		setSubfamiliasOcultas(subfamOcultas);
	}, [data]);

	const guardarFamilias = useCallback(() => {
		if (!data) return;

		const ocultas = Object.entries(familiasOcultas).map(([key, _]) => key);
		const ocultasSub = Object.entries(subfamiliasOcultas).map(([key, _]) => key);

		sendAjaxRequest("POST", "/api/v1/familiasOcultas", {
			familiasOcultas: ocultas,
			subfamiliasOcultas: ocultasSub,
		}).then(() => {
			void queryClient.invalidateQueries({ queryKey: ["familiasOcultas"] });
			notificacion("Familias guardadas correctamente");
		}).catch((err: unknown) => {
			console.error(err);
			if (err instanceof Error)
				notificacionError(`Error al guardar las familias: ${err.message}`);
			else
				notificacionError("Error al guardar las familias");
		});
	}, [data, familiasOcultas, queryClient, subfamiliasOcultas]);

	if (error) return <QueryError error={error} fallback="Error al cargar las familias ocultas" />;
	if (isPending) return <Loading />;

	return (
		<div id="content" className="content" >
			<title>Piher | Familias Ocultas</title>

			<div>
				<h1 style={{ marginBottom: 0 }}> Familias Ocultas </h1>
				<TablaFamilias familias={data.familiasERP} ocultas={familiasOcultas} setOcultas={setFamiliasOcultas} />

				<h1 style={{ marginBottom: 0 }}> Subfamilias Ocultas </h1>
				<TablaFamilias familias={data.subfamiliasERP} ocultas={subfamiliasOcultas} setOcultas={setSubfamiliasOcultas} />
			</div>

			<div style={{ marginTop: "20px", textAlign: "center" }}>
				<button className="btnPrimary" onClick={guardarFamilias} type="button" style={{ width: "75%" }}>
					Guardar
				</button>
			</div>
		</div>
	);
}




function useFamiliasOcultas() {
	return useQuery<FamiliasOcultas>({
		queryKey: ["familiasOcultas"],
		queryFn: () => {
			return sendAjaxRequest<FamiliasOcultas>("GET", "/api/v1/familiasOcultas");
		},
	});
}
export interface FamiliasOcultas {
	familiasOcultas: string[];
	subfamiliasOcultas: string[];
	familiasERP: Familia[];
	subfamiliasERP: Familia[];
}

export interface Familia {
	id: string;
	descripcion: string,
}
